import * as Lang from 'lodash/lang'
import mapValues from 'lodash/mapValues'
import isFunction from 'lodash/isFunction'
import isNaN from 'lodash/isNaN'
import moment from 'moment'

/* eslint-disable camelcase */
let functions = {
  ...Lang,
  greaterThanZero: (v) => v > 0,

  habitants: (adults, children, elderly) => {
    return !adults && !children && !elderly
  },

  /**
   * Only passes to the next validation if this passes
   */
  hasSolarSystem: ({ hasSolarSystem }) => {
    return hasSolarSystem
  },

  /**
   * Only passes to the next validation if this passes
   */
  hasCentralAirConditioning: ({ hasCentralAirConditioning }) => {
    return hasCentralAirConditioning
  },

  isElectricity: ({ offerType }) => {
    return offerType === 2
  },

  isGas: ({ offerType }) => {
    return offerType === 3
  },

  hasJointBilling: ({ has_joint_billing }) => {
    return has_joint_billing
  },

  doesNotHasConsumes: ({ has_consumes }) => {
    return has_consumes === false
  },

  // Consume validations
  noDuplicateDates: (values) => {
    let valid = true
    let errors = {}
    for (let index = 0; index < values.length; index++) {
      const element = { ...values[index] }

      element.startDate = element.startDate && moment(element.startDate)
      element.endDate = element.endDate && moment(element.endDate)

      // End date has to be greater than the start date
      if (
        !element.startDate ||
        !element.endDate ||
        !element.startDate.isBefore(element.endDate)
      ) {
        valid = false
        errors[index] = 'startDateVendDate'
        break
      } else {
        // The end and start date have to be bigger than the other values added
        if (values.length > 1) {
          for (var indexAll = 0; indexAll < values.length; indexAll++) {
            if (indexAll !== index) {
              const second = values[indexAll]
              if (element.endDate.isBetween(second.startDate, second.endDate)) {
                valid = false
                errors[index] = 'datesMustBeBiggerThanTheOthers'
                break
              }

              if (
                element.startDate.isBetween(second.startDate, second.endDate)
              ) {
                valid = false
                errors[index] = 'datesMustBeBiggerThanTheOthers'
                break
              }
            }
          }
        }
      }
    }

    return { flag: !valid, errors }
  },
  // Consume validations
  noDuplicateTimes: (values) => {
    let valid = true
    let errors = {}
    let index = 0
    for (let item in values) {
      if (['factor', 'name', 'id'].indexOf(item) === -1) {
        const itemName = item.split('_')
        if (itemName.length > 1) {
          if (itemName[1] === 'start') {
            const nStartHour = itemName[0] + '_start_hours'
            const nEndHour = itemName[0] + '_end_hours'

            const startHour =
              values[nStartHour] && values[nStartHour] !== ''
                ? moment(values[nStartHour], 'HH:mm:ss')
                : ''
            const endHour =
              values[nEndHour] && values[nEndHour] !== ''
                ? moment(values[nEndHour], 'HH:mm:ss')
                : ''
            if (startHour !== '' || endHour !== '') {
              valid = false
              errors[index] = 'startHourVendHour'
              break
            }
            index++
          }
        }
      }
    }
    return { flag: !valid, errors }
  },

  valuesGreaterThanZero: (values) => {
    let valid = true
    let errors = {}

    const mapper = (value, key) => {
      if (
        key !== 'startDate' &&
        key !== 'endDate' &&
        key !== 'startHour' &&
        key !== 'endHour'
      ) {
        const nr = Number(String(value).replace(',', '.'))

        if (isNaN(nr)) {
          valid = false
          if (!errors[index]) {
            errors[index] = {}
          }

          errors[index][key] = 'isUndefined'
        }

        if (value && (isNaN(nr) || nr < 0 || nr >= 100000)) {
          valid = false
          if (!errors[index]) {
            errors[index] = {}
          }

          errors[index][key] = 'greaterThanZero'
        }
      }
    }

    for (var index = 0; index < values.length; index++) {
      var element = values[index]

      mapValues(element, mapper)
    }

    return { flag: !valid, errors }
  },
}

functions.ignoreIf = functions
functions.not = functions

export default functions

export const Validations = mapValues(functions, (func, name) => {
  if (!isFunction(func)) {
    return mapValues(func, (f, secondName) => `${name}.${secondName}`)
  }

  return name
})

export const Messages = {
  isUndefined: (name) => `${name} é um campo obrigatório.`,
  habitants: (name) => `O numero minimo de ${name} é um.`,
  isNull: (name) => `${name} é um campo obrigatório.`,
  greaterThanZero: (name) => `${name} é um campo entre 0 e 100000`,
  startDateVendDate: (name) =>
    `A data do fim do consumo deveria ser superior à data de início`,
  startHourVendHour: (name) =>
    `A hora de encerramento deveria ser superior à hora de abertura`,
  datesMustBeBiggerThanTheOthers: (name) =>
    `A ${name} já existe inserida no alcance de outro registo.`,
  timesMustBeBiggerThanTheOthers: (name) =>
    `A ${name} já existe inserida no alcance de outro registo.`,
}



// WEBPACK FOOTER //
// ./src/validations.js